import { ClientError, } from 'graphql-request/dist/types';
export function isResponseError(e) {
    return e instanceof ClientError && 'response' in e && 'errors' in e.response;
}
//# sourceMappingURL=request.js.map